module.exports = __webpack_public_path__ + "static/media/nav_intel.92eac617.svg";